<div class="modal fade" id="openCaseModal" tabindex="-1" role="dialog" aria-labelledby="openCaseLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Opening Project</h4>
      </div>
      <div class="modal-body">
        <input id="caseFileInput" name="caseFileInput" type="file" accept=".json,.opt" />
      </div>
      <div class="modal-footer">
        <button id="download" type="button" class="btn btn-primary" (click)="uploadCase()">Load</button>
        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
